import ClientBillingSummary from "./ClientBillingSummary";
import LawyerBillingStatus from "./LawyerBillingStatus";

const BillingPage = () => {
  return (
    <div className="min-h-screen">
      <div className="max-w-5xl mx-auto space-y-10">
        
        <div className="grid lg:grid-cols-2 gap-6">
          <ClientBillingSummary />
          <LawyerBillingStatus />
        </div>
      </div>
    </div>
  );
};

export default BillingPage;
